import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-count-badge',
  standalone: true,
  imports: [],
  templateUrl: './count-badge.component.html',
  styleUrl: './count-badge.component.scss'
})
export class CountBadgeComponent {
  @Input({required:true}) count!: number;

  get displayCount(): string {
    if (this.count >= 1000) {
      return `${Math.floor(this.count / 1000)}k`;
    }
    return this.count.toString();
  }
}
